/**
 * @fileOverView
 * @description Doc Model, pulls current documentation<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandModel = require('ampersand-model');
var app = require("ampersand-app");
var logText = require('../../../lib/logtext');

var Subscription = AmpersandModel.extend({

    idAttribute: 'key',

    urlRoot: function(){
        return app.config.restApiUrl + "/subscription";
    },

    props: {
        key: 'string',
        name: 'string',
        ownerName: 'string',
        description: 'string',
        imageUrl: 'string',
        linkUrl: 'string',
        soundKey: 'string',
        soundType: 'string',
        access: 'string'
    },

    session: {
        pinging: ['boolean',true,false]
    },

    derived: {

        link: {
            deps: ['key'],
            fn: function(){
                return app.config.baseApiUrl + "/subscribe/" + this.key;
            }
        },

        imgLink: {
            deps: ['imageUrl','linkUrl'],
            fn: function(){

                var html = "";
                //the owner's urls, shown on the public subscription page
                var imageUrl = this.imageUrl && /^https?:\/\//i.test(this.imageUrl) ? logText.escapeHtml(this.imageUrl) : '';
                var linkUrl = logText.escapeHtml(logText.safeUrl(this.linkUrl));

                if(imageUrl){
                    html = '<img alt="" class="vlogimg" src="'+imageUrl+'">';

                    if(linkUrl){
                        html = '<a href="'+linkUrl+'" target="_blank" onclick="app.utils.cancelBubble()"><img alt="" class="vlogimg" src="'+imageUrl+'"></a>';
                    }
                }else if(linkUrl){
                    html = '<a href="'+linkUrl+'" target="_blank" onclick="app.utils.cancelBubble()">Destination Page</a>';
                }

                return html;

            }
        },

        subscriptionButton: {
            deps: ['access','ownerName'],
            fn: function(){
                var copy = '<div>SUBSCRIBE TO THIS VYBIT ›</div>';
                copy +=  '<div class="vsowner"> from <span data-hook="vsowner">' + logText.escapeHtml(this.ownerName || '') + '</span></div>';

                if(this.access=="private") copy += '<div class="vsubinvite">INVITATION BY OWNER REQUIRED</div>';

                return copy;
            }
        },

        soundFile: {
            deps: ['soundKey','soundType'],
            fn: function(){
                return this.soundKey + '.' + this.soundType;
            }
        },

        qrCode: {
            deps: ['key'],
            fn: function () {
                return '<img src="' + app.config.qrcodeLib + '/' + this.key + '.png">';
            }
        },

        shakeElement: {
            deps: ['pinging'],
            fn: function(){
                if(this.pinging) return true;
                else return false;
            }
        },

        followKey: {
            deps: ['key'],
            fn: function(){
                return '<button class="btn btn-sm btn-outline-success vsubbutton">SUBSCRIBE</button>';
            }
        }
    }

});

module.exports = Subscription;
